export default __webpack_public_path__ + "static/media/logo.ef7bfcda.png";